export const USER_ACTIONS = {
  CREATE_USER_FETCH: 'USER/CREATE_USER_FETCH',
  CREATE_USER_FETCH_ERROR: 'USER/CREATE_USER_FETCH_ERROR',
  SET_USER: 'USER/SET_USER',

  CHECK_USER_REQUEST: 'USER/CHECK_USER_REQUEST',
  CHECK_USER_SUCCESS: 'USER/CHECK_USER_SUCCESS',
  CHECK_USER_ERROR: 'USER/CHECK_USER_ERROR',
};
